import { createTheme } from "@mui/material";

const belowThisBreakpointIsMobile: number | "xs" | "sm" | "md" | "lg" | "xl" = "md";

export function getBreakpointForMobile() {
    return belowThisBreakpointIsMobile;
}

export const menuIconSize = 20;

const theme = createTheme();

export const toolTipTextSize = theme.typography.pxToRem(11);
export function mediaQueryNotOnMobile() {
    return theme.breakpoints.up("md");
}

const blue = "#7284FA";
const darkblue = "#002C75";
const lightBlue = "#DAEAF7";
const secondaryBlue = "#618CF5";
const white = "#FFFFFF";
const teal = "#2CD5C4";
const borderRadius = 10;
const errorRed = "#FF3F78";
const warningYellow = "#ff9800";
const disabledBackground = "#B7C0FB";
const collapseBackground = "#EFEFFA";

declare module "@mui/material/styles/createTheme" {
    interface Theme {
        customPalette: {
            collapseBackground: string;
            white: string;
        };
        customSpacing: {
            menuIconSize: number;
        };
        spacingAsNumber(spacing: number): number;
    }
    // allow configuration using `createMuiTheme`
    interface ThemeOptions {
        customPalette?: {
            collapseBackground: string;
            white: string;
        };
        customSpacing: {
            menuIconSize: number;
        };
        spacingAsNumber(spacing: number): number;
    }
}

const customerAdminWebTheme = createTheme({
    spacingAsNumber: (spacing: number) => Number(theme.spacing(spacing).slice(0, -2)),
    typography: {
        fontFamily: "Poppins, sans-serif",
    },
    palette: {
        primary: {
            dark: darkblue,
            main: blue,
            light: lightBlue,
        },
        secondary: {
            main: teal,
            light: secondaryBlue,
        },
        action: {
            disabled: white,
            disabledBackground: disabledBackground,
        },
        error: {
            main: errorRed,
        },
        warning: {
            main: warningYellow,
        },
        grey: {
            A400: "#B0BCC6",
        },
    },
    shape: {
        borderRadius: borderRadius,
    },
    customPalette: {
        collapseBackground: collapseBackground,
        white: white,
    },
    customSpacing: {
        menuIconSize: menuIconSize,
    },
    spacing: getSpacing,
    components: {
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: lightBlue,
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                outlined: {
                    borderWidth: "2px !important",
                },
                root: {
                    borderRadius: borderRadius,
                    textTransform: "none",
                },
                containedSecondary: {
                    color: white,
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: blue,
                },
                colorSecondary: {
                    color: blue,
                    "&$checked": {
                        color: blue,
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: toolTipTextSize,
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fill: blue,
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: theme.typography.pxToRem(14),
                },
            },
        },
    },
});

export default customerAdminWebTheme;

export function getSpacing(factor: number) {
    const width = window.innerWidth;
    if (width > 600) {
        return 8 * factor;
    } else {
        return 5 * factor;
    }
}
